<template>
  <div>
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">Home</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 卡片 -->
    <el-card>

      <!-- 欢迎区 -->
      <div class="welcome-area">
        <h1>Hi, {{ emailName }}!</h1>
        <p class="secondary-font">
          Welcome to EvaJudge — an efficient and consistent platform for image fusion evaluation.
        </p>
      </div>

    <div class="repo-note">
      <i class="el-icon-link"></i>
      Website updates, release notes, and feature descriptions are maintained on
      <a href="https://github.com/AWCXV/EvaNet" target="_blank">
        GitHub
      </a>.
    </div>

    <div class="about-section">

      <h2>🏫 About Us</h2>

      <p>
        ① This platform is developed by <a href="https://ai.jiangnan.edu.cn/xygk1/xyjj.htm" target="_blank">Sino-UK Joint Lab for AI</a> , Jiangnan University.
        <br>
        ② Our team focuses on multimodal image fusion and has published extensively in top-tier conferences and journals such as CVPR, ICCV, TPAMI, and IJCV.
        <br>
                ② Member details: <a href="https://awcxv.github.io/" target="_blank">Chunyang Cheng</a>,
        <a href="https://xu-tianyang.github.io/" target="_blank">Tianyang Xu</a>,
        <a href="https://hli1221.github.io/" target="_blank">Hui Li</a>,
        <a href="https://scholar.google.com/citations?user=5IST34sAAAAJ&hl=en" target="_blank">Xiao-Jun Wu*</a>,
        <a href="https://scholar.google.com/citations?user=LPPsgWUAAAAJ&hl=en" target="_blank">Tao Zhou</a>,
        <a href="https://zhangyong-tang.github.io/" target="_blank">Zhangyong Tang</a>,
        <a href="https://scholar.google.com/citations?user=pk-yb_kAAAAJ&hl=en" target="_blank">Josef Kittler</a>
        <br>

      </p>



    </div>

      <!-- 用户信息
      <div class="userCard">
        <div class="userInfo">
          <p class="important-font">{{ email }}</p>
          <p class="secondary-font">Logged in user</p>
        </div>
      </div>-->


      <!-- 使用说明 -->
      <div class="guide">
        <h2>📘 How to Use</h2>

          <ul>
          ① [Benchmarks] View and download our standard datasets.<br>
          ② [Submit] Select or create your method.<br>
          ③ [Submit] Upload zipped (.zip) fusion results (both "0" and "1" subfolders are supported).<br>
          ④ [Submit] View and click evaluation to compute metrics.<br>
          ⑤ [Leaderboard] View results in the leaderboard or metrics page.
          </ul>

        <h2>⚠️ Notes</h2>

        <ul>
          ① After 10 submissions, interval between submissions must be at least 5 minutes.<br>
          ② You are welcome to submit your papers, results, and model weights for inclusion in the Public Leaderboard (@chunyang_cheng@jiangnan.edu.cn).
        </ul>
      </div>

            <!-- 统计信息 -->
      <div class="stats">

        <el-row :gutter="12">

          <el-col :span="8">
            <el-card>
              <div class="stat-item">
                <div class="stat-title">Remaining Today</div>
                <div class="stat-value">{{ summary.remaining }}</div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card>
              <div class="stat-item">
                <div class="stat-title">Running Tasks</div>
                <div class="stat-value">{{ summary.running }}</div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="8">
            <el-card>
              <div class="stat-item">
                <div class="stat-title">Last Submission</div>
                <div class="stat-value">
                  {{ summary.last_time || "None" }}
                </div>
              </div>
            </el-card>
          </el-col>

        </el-row>

      </div>


    </el-card>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import JSZip from 'jszip';

export default {
  name: "Index",
  data() {
    return {
      email: "",
      Authorization: "",
      summary: {
        remaining: 0,
        running: 0,
        last_time: ""
      }
    };
  },
  created() {
    this.getSummary();
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (user) {
      this.Authorization = "Bearer " + user.access_token;
      this.email = user.Email || "";
    }
  },computed: {
  emailName() {
    if (!this.email) return "";
    return this.email.split("@")[0];  // ⭐ 关键
  }
  },
  methods: {
      async getSummary() {
        try {
          const res = await this.$http.get("/task_summary", {
            headers: {
              Authorization: this.Authorization   // ⭐ 关键
            }
          });

          this.summary = res.data;

        } catch (err) {
          console.error("Failed to fetch task summary", err);
        }
      },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.el-card__body {
    padding: 10px;
}

.userCard {
    height: 180px;
    display: flex;
    border-bottom: 2px solid #DCDFE6;
    border-radius: 2px;
}

.userInfo {
    width: auto;
    padding: 6% 0 0 6%;
}

.important-font {
    font-weight: 900;
    font-size: 25px;
}

.secondary-font {
    color: #909399;
}

.login-info {
    height: 40px;
    text-align: left;
    color: #909399;
}

.tableInfo {
    margin: 20px 0 0 0;
}

.OrderCard {
    margin: 0 0 30px 30px;
    border: #DCDFE6 1px solid;
    border-radius: 10px;

    i {
        width: 30%;
        line-height: 120px;
        font-size: 30px;
        color: #fff
    }

    div {
        width: 300px;
    }
}



.num {
    display: flex;
    flex-wrap: wrap;
}

.graph {
    margin: 15px 0 0 0;
}

.el-calendar {
    height: 265px;
}

.error {
    color: rgb(226, 14, 14);
}

.welcome-area {
  margin-bottom: 20px;
}

.guide {
  margin-top: 30px;
}

.guide h2 {
  margin-top: 20px;
  font-size: 18px;
  color: #2c3e50;
}

.guide ul {
  padding-left: 4px;
  color: #606266;
}

.guide li {
  margin: 8px 0;
}

.stats {
  width: 720px;        /* 控制整体宽度 */
  max-width: 100%;     /* 防止小屏幕溢出 */
  margin: 20px 0;      /* 靠左，不居中 */
}



.stat-item {
  height: 90px;        /* 比原来 110px 矮一点 */
  padding: 8px 6px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  text-align: center;
}

.stat-title {
  font-size: 14px;
  color: #909399;
  line-height: 20px;
}

.stat-value {
  font-size: 24px;     /* 比原来 28px 小一点 */
  font-weight: bold;
  color: #111827;
  line-height: 1.2;
}

.about-section a {
  color: #3fae9a;        /* 你网站主色 */
  font-weight: 500;
  text-decoration: none;
  transition: all 0.2s ease;
}

.about-section a:hover {
  color: #2c8f80;        /* hover 深一点 */
  text-decoration: underline;
}

.stat-time {
  font-size: 16px;
  margin-top: 5px;
}

.cite-section {
  margin-top: 30px;
}

::v-deep(.cite-collapse .el-collapse-item__header) {
  font-size: 18px;
  font-weight: 600;
}

.cite-text {
  font-size: 18px;
  color: #2c3e50;
}

.cite-text pre {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 13px;
  line-height: 1.6;
}

.about-section h2 {
  font-size: 18px;
  margin-bottom: 10px;
  color: #1f2a44;
}

.about-section p {
  font-size: 18px;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 8px;
}

.repo-note {
  margin: 6px 0 22px 0;
  padding: 12px 16px;
  border-radius: 10px;
  background: #f8fafc;
  color: #4b5563;
  font-size: 15px;
  line-height: 1.6;
}

.repo-note i {
  margin-right: 6px;
  color: #3fae9a;
}

.repo-note a {
  color: #3fae9a;
  font-weight: 600;
  text-decoration: none;
}

.repo-note a:hover {
  color: #2c8f80;
  text-decoration: underline;
}

</style>